import { BaseModel } from "../base-model";

export interface ISummaryCounter {
  Count: number;
  Id: number;
}
export interface ISummaryCounterSearchProperty {
  PurposeCounts?: ISummaryCounter[];
  StatusCounts?: ISummaryCounter[];
}
export class SummaryCounterSearchProperty
  extends BaseModel<ISummaryCounterSearchProperty>
  implements ISummaryCounterSearchProperty {
  PurposeCounts?: ISummaryCounter[];
  StatusCounts?: ISummaryCounter[];
  /**
   *
   */
  constructor(option?: ISummaryCounterSearchProperty) {
    super(option);
    this.PurposeCounts = this.PurposeCounts = [];
    this.StatusCounts = this.StatusCounts = [];
  }
}
